import { useState, useEffect } from "react";
import { GRADES, C } from '../constants';
import PageHeader from '../components/PageHeader';
import SiteFooter from '../components/SiteFooter';
import GradeCircle from '../components/GradeCircle';
import ConfidenceBadge from '../components/ConfidenceBadge';

export default function SharePage() {
  const [snap,    setSnap]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [err,     setErr]     = useState("");
  const id = window.location.pathname.split("/share/")[1]||"";

  useEffect(()=>{
    if (!id) { setErr("Invalid share link."); setLoading(false); return; }
    fetch(`/api/share?id=${id}`).then(r=>r.json()).then(d=>{
      if (d.analysisData) setSnap(d);
      else setErr("This analysis has expired or doesn't exist.");
      setLoading(false);
    }).catch(()=>{ setErr("Failed to load."); setLoading(false); });
  },[id]);

  return (
    <div style={{ fontFamily:"'Inter',sans-serif", background:"#000", minHeight:"100vh", color:"#fff" }}>
      <PageHeader />
      <div style={{ maxWidth:800, margin:"0 auto", padding:"32px 24px 80px" }}>
        {loading && <div style={{ color:"rgba(255,255,255,0.4)", fontSize:14, textAlign:"center", padding:"60px 0" }}>Loading analysis…</div>}
        {err && (
          <div style={{ textAlign:"center", padding:"60px 0" }}>
            <div style={{ fontSize:16, color:"rgba(255,255,255,0.5)", marginBottom:16 }}>{err}</div>
            <a href="/" style={{ color:"#e8c875", fontSize:14 }}>Run a new analysis →</a>
          </div>
        )}
        {snap && (() => {
          const d = snap.analysisData;
          const g = GRADES[d.grade]||GRADES["C"];
          const upside = (d.percentUpside||0) >= 0;
          return (
            <div>
              <div style={{ marginBottom:20, fontSize:11, color:"rgba(255,255,255,0.35)" }}>Shared analysis · {new Date(snap.createdAt).toLocaleDateString("en-US",{month:"long",day:"numeric",year:"numeric"})} · {snap.views} views</div>
              <div style={{ background:g.bg, border:`1px solid ${g.border}`, borderRadius:18, padding:"22px 20px", marginBottom:16 }}>
                <div style={{ display:"flex", gap:16, alignItems:"flex-start", flexWrap:"wrap", marginBottom:16 }}>
                  <GradeCircle grade={d.grade} score={d.score||50} size={84}/>
                  <div style={{ flex:1, minWidth:140 }}>
                    <div style={{ fontFamily:"'Cinzel',serif", fontSize:24, fontWeight:900 }}>{d.ticker}</div>
                    <div style={{ fontSize:13, color:"rgba(255,255,255,0.5)", margin:"4px 0 8px" }}>{d.companyName}</div>
                    {d.overallConfidence && <ConfidenceBadge level={d.overallConfidence}/>}
                  </div>
                  <div style={{ background:upside?"rgba(0,200,5,0.08)":"rgba(255,59,48,0.08)", border:`1px solid ${upside?"rgba(0,200,5,0.25)":"rgba(255,59,48,0.25)"}`, borderRadius:14, padding:"14px 18px", textAlign:"center" }}>
                    <div style={{ fontSize:11, textTransform:"uppercase", letterSpacing:".12em", color:upside?"#00C805":"#FF3B30", marginBottom:3 }}>Dollar {upside?"Upside":"Downside"}</div>
                    <div style={{ fontFamily:"'Rajdhani',sans-serif", fontSize:36, fontWeight:700, color:upside?"#00C805":"#FF3B30", lineHeight:1 }}>{upside?"+":"-"}${Math.abs(d.dollarUpside||0).toFixed(2)}</div>
                    <div style={{ fontSize:13, fontWeight:700, color:upside?"#00C805":"#FF3B30", marginTop:2 }}>{(d.percentUpside||0)>=0?"+":""}{(d.percentUpside||0).toFixed(1)}%</div>
                  </div>
                </div>
                <div style={{ display:"grid", gridTemplateColumns:d.analystTarget?"1fr 1fr 1fr":"1fr 1fr", gap:8 }}>
                  {[["Current Price",`$${(d.currentPrice||0).toFixed(2)}`,C.text],["Our Fair Value",`$${(d.compositeFairValue||0).toFixed(2)}`,upside?"#00C805":"#FF3B30"],...(d.analystTarget?[["Street Consensus",`$${d.analystTarget.toFixed(2)}`,d.analystTarget>d.currentPrice?"#00C805":"#FF3B30"]]:[])]
                    .map(([lbl,val,col])=>(
                      <div key={lbl} style={{ background:"rgba(255,255,255,0.04)", borderRadius:10, padding:"10px 12px" }}>
                        <div style={{ fontSize:11, textTransform:"uppercase", letterSpacing:".1em", color:"rgba(255,255,255,0.4)", marginBottom:3 }}>{lbl}</div>
                        <div style={{ fontFamily:"'Rajdhani',sans-serif", fontSize:22, fontWeight:700, color:col }}>{val}</div>
                      </div>
                    ))}
                </div>
              </div>
              <div style={{ textAlign:"center", margin:"24px 0" }}>
                <a href={`/?t=${d.ticker}`} style={{ display:"inline-block", padding:"12px 28px", background:"linear-gradient(135deg,#e8c875,#ffe87a)", color:"#000", fontWeight:700, borderRadius:12, textDecoration:"none", fontSize:14 }}>Run a Fresh Analysis →</a>
              </div>
            </div>
          );
        })()}
      </div>
      <SiteFooter />
    </div>
  );
}
